import {handleAjaxSuccess, swalConfirm} from "../../helpers/swalHelper";
import {loading, stopLoading} from "../../helpers/loading";
import Axios from "axios";
import handleAjaxError from "../../helpers/handleAjaxError";

/**
 * Initializes a button to request a password change for an user, requires
 * route window['routes/admin.users.force.password'] to be defined
 * for the button
 *
 * @param {Element} button
 */
function initForcePasswordChangeButton(button) {
	button.onclick = () => forcePasswordChange();

	function forcePasswordChange() {
		swalConfirm({
			title: 'Are you sure you want to request a password change for this user?'
		}).then(response => {
			if (response.isConfirmed) {
				loading();

				// noinspection JSUnresolvedVariable
				Axios.post(window['routes/admin.users.force.password'])
					.then(handleAjaxSuccess)
					.catch(handleAjaxError)
					.finally(stopLoading);
			}
		})
	}
}

export {initForcePasswordChangeButton}
